export default {
	ViewedMeTab: "viewedme",
	ViewsTab: "views",
};
